import { initialState } from 'appRedux/reducers/setup/systemSetup/systemConfig'
import { useSelector } from 'react-redux'
import { AppState } from 'ReducerState'

const SystemConfigState = () => {

    const systemconfig: initialState = useSelector((state: AppState) => state.systemConfig)
    const {
        loader,
        process,
        dataSource,
        systemPrepareUpdate,
    } = systemconfig

    return {
        loader,
        process,
        dataSource,
        systemPrepareUpdate
    }
}

export default SystemConfigState